import { useEffect } from "react";
// import styles from './Login.module.scss';
import { useNavigate, useSearchParams } from "react-router"; // Changed import
// import { BiLogInCircle } from 'react-icons/bi';
import { getLoginLink } from "../../service/api/loginService";
import { useAppDispatch } from "../../store/hooks";
import { checkMe, login } from "../../store/slice/loginSlice";
import "./Login.css";
// const cx = classNames.bind(styles);

const Login = () => {
  const navigate = useNavigate(); // React Router hook for navigation
  const [searchParams] = useSearchParams(); // React Router hook for URL query params
  const dispatch = useAppDispatch();

  // Note: In Create React App, client-side environment variables must be prefixed with REACT_APP_
  // If using Vite, the prefix is VITE_
  const redirectUri = process.env.REACT_APP_HOST_NAME_REDIRECT;

  const handleLogin = async () => {
    if (!redirectUri) {
      console.error(
        "Redirect URI is not defined. Please check your environment variables."
      );
      return;
    }
    const { url } = await getLoginLink(redirectUri);
    const windowFeatures =
      "menubar=no,location=no,resizable=yes,scrollbars=yes,status=yes";
    window.open(url, "_parent", windowFeatures);
  };

  useEffect(() => {
    const code = searchParams.get("code"); // Get 'code' from URL search params

    if (!code || !redirectUri) return;

    dispatch(
      login({
        code: code,
        redirectUri: redirectUri,
      })
    ).finally(() => {
      dispatch(
        checkMe({
          type: 2,
          redirectUri: redirectUri,
        })
      ).finally(() => {
        navigate("/"); // Navigate to home page
      });
    });
    // The dependency array is updated to follow React hook best practices.
  }, [searchParams, navigate, dispatch, redirectUri]);

  return (
    <>
      <main className={"login"}>
        <div className={"container"}>
          <div className={"contact"}>
            <div className={"logo"}>
              <img src="/vfast-video.png" alt="Logo vaiv eco" />
            </div>
          </div>
          <div className={"main"}>
            <h1>HaruAi BO</h1>
            <button onClick={() => handleLogin()}>
              {/* <div className={cx('icon')}>
                                <BiLogInCircle />
                            </div> */}
              <div className={"title"}>
                <span>Đăng nhập vào hệ thống</span>
              </div>
            </button>
          </div>
        </div>
      </main>
    </>
  );
};
export default Login;
